import {StyleSheet} from "react-native";
// import {STYLE_VARS} from "../../constants/style-vars";

export const menuStyled = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
    },
})